import { render, staticRenderFns } from "./WpResultItem.vue?vue&type=template&id=07c292e9&scoped=true"
import script from "./WpResultItem.vue?vue&type=script&lang=js"
export * from "./WpResultItem.vue?vue&type=script&lang=js"
import style0 from "./WpResultItem.vue?vue&type=style&index=0&id=07c292e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c292e9",
  null
  
)

export default component.exports